import { observable, IObservableArray, flow, toJS } from 'mobx';
import API from 'api';
import Query from 'utilities/Query';
import * as yup from 'yup';
import _ from 'lodash';

export default class Reminder {
	@observable id: number;
	@observable rxId: number;
	@observable itemReminderId: number;
	@observable actioned: boolean = false;
	@observable due: string;
	@observable searchPracticeName: string;
	@observable searchPracticeID: number;
	@observable searchPPID: number;
	@observable searchPrescriberName: string;
	@observable searchPatientName: string;
	@observable searchProductName: string;
	@observable created: string;
	@observable modified: string;
	@observable modifiedById: number;
	@observable modifiedBy: string;

	constructor(data: JSON = null) {
		if (data) this.extend(data);
	}

	extend(data: JSON) {
		Object.assign(this, data);
	}

	setAttributes = async val => {
		let data = this.toJS();
		if (!data.id) return;
		await API.patch(`/Reminders/${data.id}`, val);
	};

	update = flow(function*(withData) {
		if (withData) this.extend(withData);
		this.modified = new Date();
		if (this.id) {
			// Update record
			yield API.patch(`/Reminders/${this.id}`, toJS(this));
		} else {
			// New record
			this.created = new Date();
			let result = yield API.post(`/Reminders`, toJS(this));
			this.id = result.id;
		}
	});

	static loadReminders(query?: Query): Promise<{ itemCount: number, items: Array<Reminder> }> {
		if (!query) {
			query = new Query();
			query.pageSize = 1000;
		}
		return new Promise((resolve, reject) => {
			API.get(`/Reminders/items/${query.toToLpQueryUrl()}`)
				.then(result => {
					let res = {
						itemCount: result.count,
						items: result.items.map(el => new Reminder(el))
					};
					resolve(res);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	static loadById = async (id: number): Promise<Reminder> => {
		let res = await API.get(`/Reminders/${id}`);
		return new Reminder(res);
	};

	static async hasReminderEnabledPractice(accountID: number): boolean {
		const res = await API.get(
			`/AccountPrescriberPractices?filter=${JSON.stringify({
				where: { and: [{ accountID: accountID }, { disabled: false }] },
				fields: {
					id: true,
					prescriberPracticeID: true
				},
				include: {
					relation: 'PrescriberPractice',
					scope: {
						fields: ['id', 'practiceID', 'disabled'],
						include: {
							relation: 'Practice',
							scope: {
								fields: ['id', 'scheduledReminders', 'disabled']
							}
						}
					}
				}
			})}`
		);

		const result = _.find(
			res,
			o =>
				!o.PrescriberPractice?.disabled &&
				!o.PrescriberPractice?.Practice?.disabled &&
				o.PrescriberPractice?.Practice?.scheduledReminders
		);
		return result ? true : false;
	}

	toJS(): Reminder {
		return JSON.parse(JSON.stringify(this));
	}
}



// WEBPACK FOOTER //
// ./src/stores/Reminder.js